module.exports = __webpack_public_path__ + "img/bq_yx.png";